export default "__VITE_ASSET__B6FlEB11__"